/** Lighting follows real CET (UTC+1), independently of simulation speed or DST. */
export function isOfficeNight(serverTime: number): boolean {
  const hour = new Date(serverTime + 60 * 60 * 1000).getUTCHours();
  return hour >= 20 || hour < 6;
}

interface LightingPlayer {
  connected: boolean;
  activity: string;
  deskId: string;
}

/** Use replicated occupancy and player activity, including remote workers. */
export function isDeskLightOn(
  deskId: string,
  desks: ReadonlyMap<string, string>,
  players: ReadonlyMap<string, LightingPlayer>,
): boolean {
  const occupant = desks.get(deskId);
  const player = occupant ? players.get(occupant) : undefined;
  return !!(player?.connected && player.activity === "working" && player.deskId === deskId);
}
